<template>
  <section class="ead-page">
    <titlebar :title-stack="['Dashboard administrativo']" />
    <header class="box ead-hero">
      <div>
        <p class="ead-eyebrow">Visão geral da aprendizagem</p>
        <h1 class="title is-4 mb-2">Dashboard EAD</h1>
        <p class="ead-lead">Acompanhe o alcance dos treinamentos e a evolução dos colaboradores da unidade selecionada.</p>
      </div>
      <router-link class="button is-primary" :to="{ name: 'ead-relatorio' }">
        <b-icon icon="chart-box-outline" size="is-small" />
        <span>Ver relatório de progresso</span>
      </router-link>
    </header>

    <div v-if="erro" class="box ead-empty" role="alert">
      <b-icon icon="alert-circle-outline" size="is-medium" />
      <p class="has-text-weight-semibold mb-3">Não foi possível carregar os indicadores.</p>
      <b-button icon-left="refresh" @click="carregar">Tentar novamente</b-button>
    </div>
    <div v-else class="columns is-multiline indicadores-grid" :class="{ 'is-loading': loading }">
      <div v-for="i in indicadores" :key="i.nome" class="column is-4-desktop is-6-tablet">
        <article class="box indicador-card">
          <span class="indicador-icone" :class="i.classe"><b-icon :icon="i.icone" /></span>
          <div>
            <p class="indicador-nome">{{ i.nome }}</p>
            <p class="indicador-valor">{{ loading ? '—' : i.valor }}</p>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import http from '@/http'
import titlebar from '@/components/titlebar.vue'
import { mapState } from 'vuex'

export default {
  name: 'EadDashboardAdmin',
  components: { titlebar },
  data: () => ({ dados: {}, loading: false, erro: false }),
  computed: {
    ...mapState(['unidadeId']),
    indicadores() {
      return [
        { nome: 'Funcionários', valor: this.dados.funcionarios || 0, icone: 'account-group-outline', classe: 'is-info' },
        { nome: 'Cursos ativos', valor: this.dados.cursosAtivos || 0, icone: 'book-open-page-variant', classe: 'is-primary' },
        { nome: 'Em andamento', valor: this.dados.emAndamento || 0, icone: 'play-circle-outline', classe: 'is-link' },
        { nome: 'Concluídos', valor: this.dados.concluidos || 0, icone: 'check-circle-outline', classe: 'is-success' },
        { nome: 'Pendentes', valor: this.dados.pendentes || 0, icone: 'clock-outline', classe: 'is-warning' },
      ]
    },
  },
  watch: { unidadeId: 'carregar' },
  mounted() { this.carregar() },
  methods: {
    carregar() {
      this.loading = true
      this.erro = false
      http.get('/api/ead-relatorios/dashboard', { params: { unidadeId: this.unidadeId } })
        .then((r) => { this.dados = r.data || {} })
        .catch(() => { this.erro = true })
        .finally(() => { this.loading = false })
    },
  },
}
</script>

<style scoped>
.indicadores-grid { margin-top: 0.25rem !important; }
.indicador-card { align-items: center; display: flex; gap: 1rem; height: 100%; min-height: 126px; padding: 1.35rem; }
.indicador-icone { align-items: center; background: #e9f5f3; border-radius: 14px; color: #008f7c; display: inline-flex; flex: 0 0 3.3rem; height: 3.3rem; justify-content: center; }
.indicador-icone.is-info { background: #eaf5fb; color: #16729c; }
.indicador-icone.is-link { background: #eef1fb; color: #5268a9; }
.indicador-icone.is-success { background: #eaf7ed; color: #25814a; }
.indicador-icone.is-warning { background: #fff5e2; color: #ac6d0a; }
.indicador-nome { color: #63787b; font-size: 0.83rem; font-weight: 700; }
.indicador-valor { color: #173b40; font-size: 2rem; font-weight: 800; line-height: 1.2; margin-top: 0.2rem; }
.is-loading { opacity: 0.65; }
</style>
